import { Component, OnInit, OnChanges, Input, SimpleChanges, OnDestroy } from "@angular/core";
// ngrx store
import { Store } from "@ngrx/store";
// models
import { AppState } from "../../../models/app-state.interface";
import { take } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
  selector: "app-subsidy",
  templateUrl: "./subsidy.component.html",
  styleUrls: ["./subsidy.component.scss"],
})
export class SubsidyComponent implements OnInit, OnDestroy {

  private _bookingStateSubscription: Subscription;

  @Input()
  appCopy;

  @Input()
  appAirportCopy;

  @Input()
  selectedLanguage;

  @Input()
  isSbbSubsidyApplicable;

  @Input()
  isDbSubsidyApplicable;

  @Input()
  isCatDiscountApplicable;

  public airportCode = "";
  public isLhSubsidyApplicable = false;
  public isRailOnly = false;

  public isSubsidyAppliedPublic: boolean = true;
  public isDbSubsidyAppliedPublic: boolean = false;
  public isLhSubsidyAppliedPublic: boolean = false;
  public isCatDiscountAppliedPublic: boolean = false;

  constructor(private _appStore: Store<AppState>) { }

  ngOnInit(): void {
    const state = this.getState(this._appStore);
    const productType = state.bookingReducer.bookingDetails.bookingProduct;

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {
        this.isSubsidyAppliedPublic = bookingState.bookingDetails.isSbbSubsidyApplied;
        this.isDbSubsidyAppliedPublic = bookingState.bookingDetails.isDbSubsidyApplied;
        this.isLhSubsidyAppliedPublic = bookingState.bookingDetails.isLhSubsidyApplied;
        // this.isCatDiscountAppliedPublic = bookingState.bookingDetails.isCatDiscountApplied;
      });

    if (this.isDbSubsidyApplicable && state.bookingReducer.bookingDetails.dbSubsidyType !== null) {
      this._appStore.dispatch({
        type: "UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS",
        payload: true,
      });
    }

    if (this.isDbSubsidyApplicable && state.bookingReducer.bookingDetails.dbSubsidyType === null) {
      this.isLhSubsidyApplicable = true;
    }

    // if land from dotcom and type is expressrail then only show LH subsidy
    if (this.isDbSubsidyApplicable && state.bookingReducer.bookingDetails.dbSubsidyType === 0) {
      this._appStore.dispatch({
        type: "UPDATE_SBB_PUBLIC_TRANSPORT_LH_DISCOUNT_STATUS",
        payload: true
      });
      this.isLhSubsidyApplicable = true;
      this.isLhSubsidyAppliedPublic = true;
      this.isRailOnly = true;
    }

    const flightRespone = state.flightReducer.flightDetails.flightResponse;
    this.airportCode = productType === "abc" ? flightRespone.flightStatusDetails[0].departureAirport.airportCode : flightRespone.flightStatusDetails[flightRespone.flightStatusDetails.length - 1].arrivalAirport.airportCode;
    // if (state.d2dReducer.hasSession) {
    // } else {
    //   const flightStatusDetails = state.flightFinderReducer.selectedMultiLegFlight.flightStatusDetails;
    //   this.airportCode = productType === "abc" ? flightStatusDetails[0].departureAirport.airportCode : flightStatusDetails[flightStatusDetails.length - 1].arrivalAirport.airportCode
    // }
  }

  publicTransportSubsidy(val: any) {
    this._appStore.dispatch({
      type: "UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS",
      payload: val.target.checked,
    });
  }

  catDiscount(val: any) {
    const value = val.target.checked;
    this.isCatDiscountAppliedPublic = value;

    this._appStore.dispatch({
      type: "UPDATE_CAT_DISCOUNT_STATUS",
      payload: value,
    });
  }

  publicTransportDBSubsidy(val: any) {
    const value = val.target.checked;
    this.isDbSubsidyAppliedPublic = value;

    this._appStore.dispatch({
      type: "UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS",
      payload: value
    });

    if (this.isLhSubsidyApplicable) {
      this.isLhSubsidyAppliedPublic = false;

      this._appStore.dispatch({
        type: "UPDATE_SBB_PUBLIC_TRANSPORT_LH_DISCOUNT_STATUS",
        payload: false
      });
    }

  }

  // const mapDBServices = {railandfly: 1, expressrail: 0};
  publicTransportLHSubsidy(val: any) {
    const value = val.target.checked;
    this.isDbSubsidyAppliedPublic = false;
    this.isLhSubsidyAppliedPublic = value;

    this._appStore.dispatch({
      type: "UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS",
      payload: false
    });

    this._appStore.dispatch({
      type: "UPDATE_SBB_PUBLIC_TRANSPORT_LH_DISCOUNT_STATUS",
      payload: value
    });

  }

  getState(store: Store<AppState>) {
    let state: AppState;
    store.pipe((take(1)))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._bookingStateSubscription.unsubscribe();
  }
}
